import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { InputText } from "primereact/inputtext";
import validator from 'validator'
import Utils from "../../utilities/Utils";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { TextComponent } from "./TextComponent";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class EmailComponent extends TextComponent {


  constructor(props: Props) {
    super(props);
  }

  onBlur = (e: any) => {
    let field = this.props.field;
    FormValidationUtils.validateEmail(field);
    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  onTextEditChange = (e) => {
    let field = this.props.field;
    let val = e.target.value;
    field.Value = val;

    FormValidationUtils.runKeyStrokeJavascript(field);

    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

}